/**
 * Canonical viewport for all renderer surfaces.
 * Must stay in sync with `src/renderer/index.html` <meta name="viewport" content="...">.
 */
export const CANONICAL_VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1.0, viewport-fit=cover' as const;

/** Ensures document viewport meta matches the canonical string (zoom allowed). */
export function applyCanonicalViewportMeta(): void {
  if (typeof document === 'undefined') {
    return;
  }
  let meta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'viewport';
    document.head.appendChild(meta);
  }
  if (meta.content !== CANONICAL_VIEWPORT_CONTENT) {
    meta.content = CANONICAL_VIEWPORT_CONTENT;
  }
}
